// Full-document render of the pillows generic FormPage: the UtilityPage shell
// (PageSkeleton + side nav + content title + right bar) with the rich-text intro
// and the Wagtail form-builder form in content__copy. The form fields are
// rendered natively in React from the per-field FormFieldData serialization (the
// form is built dynamically from CMS form_fields, so reactivated's FormType
// can't serialize it).
import React from "react";
import { FormPageFields } from "tsi-common-react/src/forms/FormPageFields/index";
import { jt } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { PageSkeleton } from "../components/PageSkeleton";
import { SideNav } from "../components/SideNav";

export const Template = (
    props: templates.FormPageTemplate,
): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        has_right_bar,
        right_bar,
        content_title,
        phone_display,
        phone_href,
        intro_html,
        action_url,
        fields,
    } = props;
    // ttag's `jt` forbids a conditional/logical expression directly inside the
    // `${...}` interpolation, so compute the optional phone link first.
    const phoneLink = phone_display ? (
        <a key="phone" href={phone_href}>
            {phone_display}
        </a>
    ) : null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
                {has_nav && (
                    <div className="l-side-nav">
                        <SideNav items={side_nav} />
                    </div>
                )}

                <div className="l-side-nav-content">
                    <div className="content-title">
                        <h1 className="content-title__headline">
                            {content_title}
                        </h1>
                        <span className="content-title__info">
                            {jt`Talk to Sleep Expert ${phoneLink}`}
                        </span>
                    </div>

                    <div
                        className={
                            has_right_bar
                                ? "content__copy"
                                : "content__copy--full-width"
                        }
                    >
                        {/* form_page.html's {% block extra_body %} wraps the
                            intro + form in a bare <div>. */}
                        <div>
                            <div
                                className="rich-text"
                                dangerouslySetInnerHTML={{ __html: intro_html }}
                            />
                            <form action={action_url} method="POST">
                                <CSRFToken />
                                <FormPageFields fields={fields} />
                                <input type="submit" />
                            </form>
                        </div>
                    </div>

                    {has_right_bar && (
                        <aside className="content__aside">
                            {right_bar.map((item, i) =>
                                item.block_type === "right_bar_section" ? (
                                    <div
                                        key={i}
                                        className={`w-block-${item.block_type} block-${item.block_type}`}
                                    >
                                        <h1 className="content__aside__title">
                                            {item.header}
                                        </h1>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: item.body_html,
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <EditorContent key={i}>
                                        {(marker) => (
                                            <div
                                                className={`w-block-${item.block_type} block-${item.block_type}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: item.body_html,
                                                }}
                                                {...marker}
                                            />
                                        )}
                                    </EditorContent>
                                ),
                            )}
                        </aside>
                    )}
                </div>
            </div>
        </PageSkeleton>
    );
};
